export const GET_DISPLAY_CATEGORIES_REQUESTED =
  'GET_DISPLAY_CATEGORIES_REQUESTED'
export const GET_DISPLAY_CATEGORIES_SUCCEEDED =
  'GET_DISPLAY_CATEGORIES_SUCCEEDED'
export const GET_DISPLAY_CATEGORIES_FAILED =
  'GET_DISPLAY_CATEGORIES_FAILED'

export const UPDATE_DISPLAY_CATEGORIES_REQUESTED =
  'UPDATE_DISPLAY_CATEGORIES_REQUESTED'
export const UPDATE_DISPLAY_CATEGORIES_SUCCEEDED =
  'UPDATE_DISPLAY_CATEGORIES_SUCCEEDED'
export const UPDATE_DISPLAY_CATEGORIES_FAILED =
  'UPDATE_DISPLAY_CATEGORIES_FAILED'

export const CREATE_DISPLAY_CATEGORY_REQUESTED =
  'CREATE_DISPLAY_CATEGORY_REQUESTED'
export const CREATE_DISPLAY_CATEGORY_SUCCEEDED =
  'CREATE_DISPLAY_CATEGORY_SUCCEEDED'
export const CREATE_DISPLAY_CATEGORY_FAILED =
  'CREATE_DISPLAY_CATEGORY_FAILED'

export const SELECT_ITEMS_ASSIGNED_TO_DISPLAY_CATEGORY =
  'SELECT_ITEMS_ASSIGNED_TO_DISPLAY_CATEGORY'
export const SET_DISPLAY_CATEGORIES_SORTING_MODE = `SET_DISPLAY_CATEGORIES_SORTING_MODE`
export const SET_DISPLAY_CATEGORIES_INDEXES =
  'SET_DISPLAY_CATEGORIES_INDEXES'
